module.exports = __webpack_public_path__ + "static/media/25.2d3f99de.png";